var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-container container px-md-0"},[_c('div',{class:{ 'has-bottom-bar': _vm.showBottomBar }},[_c('router-view')],1),_vm._v(" "),(_vm.showBottomBar)?_c('agent-bottom-bar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }